var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item",style:({width: _vm.widthC})},[_c('FormItem',_vm._b({},'FormItem',{error: _vm.error},false),[_vm._t("label",[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))])]),_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }